import { Directive, Input } from "@angular/core";
@Directive()
export abstract class CellRendererBase {
    @Input() cellValue: string = '';
    
}
